export type KomponenKegiatan = {
  master_komponen_kegiatan_id: number;
  kode_komponen: string;
  komponen_kegiatan: string;
  master_unsur_id: number;
  kode_alternatif: string;
  satuan: string;
  sumber_data: string;
  is_active_banding: number;
  keterangan_komponen: string;
  created_at: string;
  updated_at: string | null;
  deleted_at: string | null;
};

export type KomponenKegiatanResponse = {
  datas: KomponenKegiatan[];
  is_next: boolean;
  status: string;
};

import { apiClient } from "@/lib/api-client";

export const fetchKomponenKegiatan = async ({ pageParam = 1 }: { pageParam?: number } = {}): Promise<KomponenKegiatanResponse> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  return apiClient<KomponenKegiatanResponse>(`${baseUrl}/api/v1/master-komponen-kegiatan?page=${pageParam}`);
};
